export default {
	id: {
		title: 'default.id2',
		field: 'id',
		locked: true
	},
	title: {
		title: 'support.title',
		field: 'title',
		locked: true
	},
	client: {
		title: 'default.account',
		field: 'client.name'
	},
	contact: {
		title: 'support.requester',
		field: 'contact.name'
	},
	user: {
		title: 'support.assignee',
		field: 'user.name'
	},
	status: {
		title: 'support.status',
		field: 'status.name'
	},
	type: {
		title: 'defaultView.ticketType',
		field: 'type.name'
	},
	priority: {
		title: 'ticket.priority',
		field: 'priority'
	},
	emailUsed: {
		title: 'support.supportEmail',
		field: 'emailUsed'
	},
	source: {
		title: 'ticket.source',
		field: 'source'
	},
	regDate: {
		title: 'support.created',
		field: 'regDate'
	},
	resolveDate: {
		title: 'support.closed',
		field: 'resolveDate'
	},
	lastUpdated: {
		title: 'support.updated',
		field: 'lastUpdated'
	},
	firstReplyDate: {
		title: 'ticket.firstReplyDate',
		field: 'firstReplyDate'
	},
	firstResolveDate: {
		title: 'support.firstClosed',
		field: 'firstResolveDate'
	},
	regBy: {
		title: 'default.createdBy',
		field: 'regBy.name'
	}
};
